/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { useTranslation } from "common/utils/i18n"
import {
  replaceRegexes,
  ReplaceRegexOption,
  replaceWithReactChild,
} from "utils/i18n"

// Plural and singular converter, it also support more than one replacement
// Your language noun also need singular and plural key, consider create translation map like this in config.rb
// {your noun}.singular & {your noun}.plural
// usage
// useTranslateSingularAndPlural(
//   "ordermanager.itemcount.food",
//   count,
//   {
//     "x": "10",
//     "customer.name": "customer name"
//   }
// )
export const useTranslateSingularAndPlural = (
  noun: string,
  count: number,
  replacementMap: { [key: string]: string },
  replaceRegex?: ReplaceRegexOption,
): string => {
  // find singular and plural translation
  const singularNounTranslation = useTranslation(`${noun}.singular`)
  const pluralNounTranslation = useTranslation(`${noun}.plural`)
  const replaceRgx = replaceRegex || replaceRegexes.arrowBrackets

  if (count > 1) {
    return replaceWithReactChild(pluralNounTranslation, replacementMap, {
      replaceRegex: replaceRgx,
    }) as string
  }

  return replaceWithReactChild(singularNounTranslation, replacementMap, {
    replaceRegex: replaceRgx,
  }) as string
}
